import React from 'react';
import { useNavigate } from 'react-router-dom';

const SmartLink = ({ to, children, className, fadeDuration = 850, ...props }) => {
    const navigate = useNavigate();

    const handleClick = (e) => {
        e.preventDefault();

        // Remove page state classes to trigger fade-out
        const classesToRemove = [
            'state-page-loaded', 'state-menu-open', 'state-page-load-complete',
            'state-splash-header', 'state-front-page', 'state-scrolled',
            'state-show-splash', 'state-show-block'
        ];
        classesToRemove.forEach(cls => document.documentElement.classList.remove(cls));

        // Optional: lock scroll during transition
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';

        console.log('Navigating to', to);

        // Wait for fade duration before navigating
        setTimeout(() => {
            navigate(to);
            console.log('Navigated to', to);
            // Unlock scroll after navigation
            document.documentElement.style.overflow = '';
            document.body.style.overflow = '';
        }, fadeDuration);
    };

    return (
        <a href={to} onClick={handleClick} className={className} {...props}>
            {children}
        </a>
    );
};

export default SmartLink;
